import React from "react";
import { Form, Input, Button, Space } from "antd";

import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
export default function addGuests() {
  return (
    <Form.List name="guests">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <Space
              key={key}
              style={{ display: "flex", marginBottom: 8, flexWrap: "wrap" }}
              align="baseline"
            >
              <Form.Item
                {...restField}
                name={[name, "first"]}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: "Missing first name",
                  },
                ]}
                style={{ marginBottom: 8 }}
              >
                <Input placeholder="First Name" />
              </Form.Item>
              <Form.Item
                {...restField}
                name={[name, "last"]}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: "Missing last name",
                  },
                ]}
                style={{ marginBottom: 8 }}
              >
                <Input placeholder="Last Name" />
              </Form.Item>

              <MinusCircleOutlined onClick={() => remove(name)} />
            </Space>
          ))}
          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              Add Guest Name
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
}
